import { Graphics } from 'pixi.js';

import { ClientGlobalSystem } from './ClientBase';

/**
 * Debug system that renders entity hitboxes (colliders).
 */
export class DebugHitboxRenderSystem extends ClientGlobalSystem {
  private graphics: Graphics | null = null;

  run(): void {
    const world = this.getWorld();
    const showHitboxes = this.clientServices.debug.state.showHitboxes;

    // Create graphics if not exists
    if (!this.graphics) {
      this.graphics = new Graphics();
      this.graphics.zIndex = 100002; // Above arcs
      this.clientServices.render.stage?.addChild(this.graphics);
    }

    this.graphics.visible = showHitboxes;
    this.graphics.clear();

    if (!showHitboxes) {
      return;
    }

    // Query all entities with Transform or GlobalTransform
    const entities = world.query(['Transform']);

    for (const entityId of entities) {
      // Use GlobalTransform for correct world-space positioning (handles hierarchies)
      const transform =
        world.getComponent(entityId, 'GlobalTransform') ??
        world.getComponent(entityId, 'Transform')!;
      const collider = world.getComponent(entityId, 'Collider');
      const hitbox = world.getComponent(entityId, 'Hitbox');

      if (collider) {
        this.drawRect(transform.x, transform.y, collider, 0x00ffff); // Cyan for colliders
      }

      if (hitbox) {
        this.drawRect(transform.x, transform.y, hitbox, 0xff0000); // Red for hitboxes
      }
    }
  }

  private drawRect(
    x: number,
    y: number,
    data: { width: number; height: number; offsetX: number; offsetY: number },
    color: number,
  ): void {
    if (!this.graphics) return;

    const alpha = 0.5;
    const fillAlpha = 0.1;

    this.graphics.fill({ color, alpha: fillAlpha });
    this.graphics.rect(x + data.offsetX, y + data.offsetY, data.width, data.height);
    this.graphics.stroke({ color, alpha, width: 1 });
  }
}
